const config = {
  API_URL: "https://cl61sgtmuc.execute-api.ap-south-1.amazonaws.com",
};

export default config;
